import {createRouter, createWebHistory} from 'vue-router'
import {overWriteRoute, findRoutes} from '@moeinmdn/miw-router/src/package/RouterFunctions'
import {routes as DefaultRoutes} from '@moeinmdn/miw-router/src/package'
import multiguard from "vue-router-multiguard";
import store from '@/store'
import {i18n} from "@/main";
import {guardsObject} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";
import {
    getAxiosInstance,
    getRouteInstance,
    getStoreInstance,
    getI18nInstance,
    initAxios, initI18n,
    initRouter,
    initStore
} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance";


import Home_faComponent from '../views/fa/Home';overWriteRoute(DefaultRoutes, 'Home', {components: {site:Home_faComponent},meta:{language:'fa',panel:['*']}});import SiteLayout_faComponent from '../views/fa/SiteLayout';overWriteRoute(DefaultRoutes, 'SiteLayout', {component: SiteLayout_faComponent,language:'fa'});import NotFound_faComponent from '../views/fa/NotFound';overWriteRoute(DefaultRoutes, 'NotFound', {components: {site:NotFound_faComponent},meta:{language:'fa',panel:['*']}});import Login_faComponent from '../views/fa/Login';overWriteRoute(DefaultRoutes, 'Login', {components: {site:Login_faComponent},meta:{language:'fa',panel:['*']}});import Register_faComponent from '../views/fa/Register';overWriteRoute(DefaultRoutes, 'Register', {components: {site:Register_faComponent},meta:{language:'fa',panel:['*']}});import VerifiedCellphone_faComponent from '../views/fa/VerifiedCellphone';overWriteRoute(DefaultRoutes, 'VerifiedCellphone', {components: {site:VerifiedCellphone_faComponent},meta:{language:'fa',panel:['*']}});import ForgetPassword_faComponent from '../views/fa/ForgetPassword';overWriteRoute(DefaultRoutes, 'ForgetPassword', {components: {site:ForgetPassword_faComponent},meta:{language:'fa',panel:['*']}});import CellphoneResetPassword_faComponent from '../views/fa/CellphoneResetPassword';overWriteRoute(DefaultRoutes, 'CellphoneResetPassword', {components: {site:CellphoneResetPassword_faComponent},meta:{language:'fa',panel:['*']}});import EmailResetPassword_faComponent from '../views/fa/EmailResetPassword';overWriteRoute(DefaultRoutes, 'EmailResetPassword', {components: {site:EmailResetPassword_faComponent},meta:{language:'fa',panel:['*']}});import VerifiedEmail_faComponent from '../views/fa/VerifiedEmail';overWriteRoute(DefaultRoutes, 'VerifiedEmail', {components: {site:VerifiedEmail_faComponent},meta:{language:'fa',panel:['*']}});import Products_faComponent from '../views/fa/Products';overWriteRoute(DefaultRoutes, 'Products', {components: {site:Products_faComponent},meta:{language:'fa',panel:['*']}});import Product_faComponent from '../views/fa/Product';overWriteRoute(DefaultRoutes, 'Product', {components: {site:Product_faComponent},meta:{language:'fa',panel:['*']}});import Delivery_faComponent from '../views/fa/Delivery';overWriteRoute(DefaultRoutes, 'Delivery', {components: {site:Delivery_faComponent},meta:{language:'fa',panel:['*']}});import ShoppingCart_faComponent from '../views/fa/ShoppingCart';overWriteRoute(DefaultRoutes, 'ShoppingCart', {components: {site:ShoppingCart_faComponent},meta:{language:'fa',panel:['*']}});import UnAuthenticatedShoppingCart_faComponent from '../views/fa/UnAuthenticatedShoppingCart';overWriteRoute(DefaultRoutes, 'UnAuthenticatedShoppingCart', {components: {site:UnAuthenticatedShoppingCart_faComponent},meta:{language:'fa',panel:['*']}});import Factor_faComponent from '../views/fa/Factor';overWriteRoute(DefaultRoutes, 'Factor', {components: {site:Factor_faComponent},meta:{language:'fa',panel:['*']}});import verifyTransaction_faComponent from '../views/fa/verifyTransaction';overWriteRoute(DefaultRoutes, 'verifyTransaction', {components: {site:verifyTransaction_faComponent},meta:{language:'fa',panel:['*']}});import verifyTransactionWithoutAuthentication_faComponent from '../views/fa/verifyTransactionWithoutAuthentication';overWriteRoute(DefaultRoutes, 'verifyTransactionWithoutAuthentication', {components: {site:verifyTransactionWithoutAuthentication_faComponent},meta:{language:'fa',panel:['*']}});import Posts_faComponent from '../views/fa/Posts';overWriteRoute(DefaultRoutes, 'Posts', {components: {site:Posts_faComponent},meta:{language:'fa',panel:['*']}});import SinglePost_faComponent from '../views/fa/SinglePost';overWriteRoute(DefaultRoutes, 'SinglePost', {components: {site:SinglePost_faComponent},meta:{language:'fa',panel:['*']}});import Pages_faComponent from '../views/fa/Pages';overWriteRoute(DefaultRoutes, 'Pages', {components: {site:Pages_faComponent},meta:{language:'fa',panel:['*']}});import SinglePage_faComponent from '../views/fa/SinglePage';overWriteRoute(DefaultRoutes, 'SinglePage', {components: {site:SinglePage_faComponent},meta:{language:'fa',panel:['*']}});import Categories_faComponent from '../views/fa/Categories';overWriteRoute(DefaultRoutes, 'Categories', {components: {site:Categories_faComponent},meta:{language:'fa',panel:['*']}});import Brands_faComponent from '../views/fa/Brands';overWriteRoute(DefaultRoutes, 'Brands', {components: {site:Brands_faComponent},meta:{language:'fa',panel:['*']}});import SingleCategory_faComponent from '../views/fa/SingleCategory';overWriteRoute(DefaultRoutes, 'SingleCategory', {components: {site:SingleCategory_faComponent},meta:{language:'fa',panel:['*']}});import SingleBrand_faComponent from '../views/fa/SingleBrand';overWriteRoute(DefaultRoutes, 'SingleBrand', {components: {site:SingleBrand_faComponent},meta:{language:'fa',panel:['*']}});import PostCategories_faComponent from '../views/fa/PostCategories';overWriteRoute(DefaultRoutes, 'PostCategories', {components: {site:PostCategories_faComponent},meta:{language:'fa',panel:['*']}});import Search_faComponent from '../views/fa/Search';overWriteRoute(DefaultRoutes, 'Search', {components: {site:Search_faComponent},meta:{language:'fa',panel:['*']}});import VerifyEmailRequest_faComponent from '../views/fa/VerifyEmailRequest';overWriteRoute(DefaultRoutes, 'VerifyEmailRequest', {components: {site:VerifyEmailRequest_faComponent},meta:{language:'fa',panel:['*']}});import SingleChat_faComponent from '../views/fa/SingleChat';overWriteRoute(DefaultRoutes, 'SingleChat', {components: {site:SingleChat_faComponent},meta:{language:'fa',panel:['*']}});import Category_faComponent from '../views/fa/Category';overWriteRoute(DefaultRoutes, 'Category', {components: {site:Category_faComponent},meta:{language:'fa',panel:['*']}});import TrashCategory_faComponent from '../views/fa/TrashCategory';overWriteRoute(DefaultRoutes, 'TrashCategory', {components: {site:TrashCategory_faComponent},meta:{language:'fa',panel:['*']}});import Dashboard_faComponent from '../views/fa/Dashboard';overWriteRoute(DefaultRoutes, 'Dashboard', {components: {site:Dashboard_faComponent},meta:{language:'fa',panel:['*']}});


function setFilters(language) {
    let languageFilter = (languages[language] == null || languages[language] == '') ? language : languages[language]
    store.commit('Product/setFilters', {key: 'language', value: languageFilter})
    store.commit('Brand/setFilters', {key: 'language', value: languageFilter})
    store.commit('Content/setFilters', {key: 'language', value: languageFilter})
    store.commit('Category/setFilters', {key: 'language', value: languageFilter})
    store.commit('Menu/setFilters', {key: 'language', value: languageFilter})
    store.commit('Search/setFilters', {key: 'language', value: languageFilter})
    store.commit('Course/setFilters', {key: 'language', value: languageFilter})
    const i18n = getI18nInstance()
    i18n.global.locale = language
}

const flatRouter = (routes) => {
    return Array.isArray(routes)
        ? routes.reduce((a, item) => {
            a.push(item);
            if (item.children) {
                a = a.concat(flatRouter(item.children));
            }
            return a;
        }, []) : [];
}

export let defaultLanguage = 'fa'
export let languages = {'fa':'',}

function findLanguage() {
    let currentRoute = window.location.pathname.split('/')
    currentRoute = currentRoute.filter(item => item.length > 0)
    if (currentRoute.length > 0) {
        const language = currentRoute[0]
        if (Object.keys(languages).indexOf(language) > -1) {
            return language
        }
    }
    return defaultLanguage
}

let language = findLanguage()

// remove un related routes to current language
DefaultRoutes.forEach((item, index) => {
    let itemName = item.name
    if (itemName != 'NotFound' && item.language != language) {
        delete DefaultRoutes[index]
    }
})

export const guardManager = (panels) => {
    let guardsNames = Object.keys(guardsObject());
    let guards = [];

    panels.forEach(panel => {
        let guardChecker = panel.substring(0, 2) === 'G-';
        if (guardChecker) {
            let guardName = panel.replace('G-', '');
            if (guardsNames.includes(guardName)) {
                guards.push(guardsObject()[guardName]);
            }
        }
    });

    return guards;
};

// rename DefaultRoutes to normal
flatRouter(DefaultRoutes).forEach((item, index) => {
    item.name = item.name.split('_')[0]

    if (item.meta != undefined) {
        let panels = item.meta.panel
        item.beforeEnter = multiguard(guardManager(panels))

    }
})

export const checkRouterAccess = (routerTo) => {
    let routerPanels = routerTo.meta.panel
    let user = store.getters['User/getProfile']
    let result = {
        status: false,
        route: null
    }

    // if page is accessible for all let user pass
    if (routerPanels == null || Object.keys(routerPanels).length === 0 || routerPanels.indexOf('*') > -1) {
        result.status = true
        return result
    }

    // if user not sign in we return false
    if ((user == null || Object.keys(user).length === 0) && Object.keys(routerPanels).length > 0) {
        result.route = {name: 'Login'}
        return result
    }

    // check user access when login
    let userPanels = user.panels.map(item => {
        return item.language.slug
    })
    routerPanels.forEach(item => {
        if (userPanels.indexOf(item) > -1) {
            result.status = true
        }
    })

    return result

}

const routes = DefaultRoutes

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


const setBodyTagClassName = (to) => {
    const body = document.body;

    // Add a custom class based on the route name
    if (to.name) {
        body.id = `${language}-${to.name.toLowerCase()}`;
    }
}


router.beforeEach((to, from) => {


    setBodyTagClassName(to)

    setFilters(language)
    if (Object.keys(store.getters['Menu/getAllMenus']).length == 0) {
        store.dispatch("Menu/getMenus");
    }


    let checkUserAccess = checkRouterAccess(to);
    let userAccessStatus = !checkUserAccess.status
    let userAccessRoute = checkUserAccess.route

    // Check if the current route is "NotFound" to prevent infinite route pushes
    if (to.name !== "AccessDenied" && userAccessStatus) {
        if (userAccessRoute != null) {
            router.push(userAccessRoute);
        } else {
            router.push({name: 'AccessDenied'});
        }


    }
    return true

})

export default router
